import { actionCreatorFactory } from 'typescript-fsa';
import type { CartItems, ArrowType, OrderType } from '@app/react/const/type';

const ac = actionCreatorFactory('cart');

export interface FetchCartItemParam {
    cartId: number;
    arrowType: ArrowType;
    orderType: OrderType;
}

export interface FetchCartItemResult {
    cartId: number;
    designSet: CartItems;
}

export interface FetchCartItemError {
    status: number;
    statusText: string;
}

export const fetchCartItemAction = ac.async<
    FetchCartItemParam, FetchCartItemResult, FetchCartItemError>('fetchCartItemAction');
